/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    toggle: PropTypes.bool,
    toggleMediumScreen: PropTypes.bool,
};

const defaultProps = {
    toggle: false,
    toggleMediumScreen: false,
};

const DisableBodyScroll = ({ toggle, toggleMediumScreen }) => (
    <style>
        {`
            body { 
                overflow: ${toggle ? 'hidden' : 'auto'}
            }

            @media screen and (min-width: 768px) {
                body { 
                    overflow: ${toggleMediumScreen ? 'hidden' : 'auto'}
                }   
            }
        `}
    </style>
);

DisableBodyScroll.propTypes = propTypes;
DisableBodyScroll.defaultProps = defaultProps;

export default DisableBodyScroll;
